import { createPortal } from "react-dom";
import { BoxRect } from "../hooks/boxSelectUtils";
import { SELECTED_STROKE } from "../hooks/talhaoSelectionColors";

type BoxSelectOverlayProps = {
  boxRect: BoxRect | null;
  containerId?: string;
};

function BoxSelectOverlay({ boxRect, containerId = "map-print-area" }: BoxSelectOverlayProps) {
  if (!boxRect || boxRect.width === 0 || boxRect.height === 0) return null;

  const container = document.getElementById(containerId);
  if (!container) return null;

  return createPortal(
    <div
      style={{
        position: "absolute",
        left: boxRect.left,
        top: boxRect.top,
        width: boxRect.width,
        height: boxRect.height,
        border: `2px solid ${SELECTED_STROKE}`,
        backgroundColor: "rgba(255, 0, 0, 0.15)",
        pointerEvents: "none",
        zIndex: 1000,
        boxSizing: "border-box",
      }}
    />,
    container
  );
}

export default BoxSelectOverlay;
